import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import Home from './views/Home.vue'
import Select from './views/Select.vue'
import Answer from './views/Answer.vue'
import Rank from './views/Rank.vue'
import AI from './views/AIAnswer.vue'
import HJR from './views/AIHJAnswer.vue'
import AIRole from './views/AIRoleAnswer.vue'

import 'nprogress/nprogress.css'

Vue.use(Router)

let router = new Router({
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  },{
    path: '/select',
    name: 'select',
    component: Select
  },{
    path: '/answer',
    name: 'answer',
    component: Answer
  },{
    path: '/rank',
    name: 'rank',
    component: Rank
  },{
    path: '/ai',
    name: 'ai',
    component: AI
  },{
    path: '/hjr',
    name: 'hjr',
    component: HJR
  },{
    path: '/airole',
    name: 'airole',
    component: AIRole
  },]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router = router;